import React, { useState, useEffect } from "react"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import List from "@bappweb/list"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import Block from "@bappweb/block"
import Link from "@bappweb/link"
import { getCidParameter, getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"
import { useAppSelector } from "../../../config/hook"

const SssList = (props) => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [faqText, setFaqText] = useState<any[]>([]);
  let cidParameter = getCidParameter();
  useEffect(() => {
    if (sessionData?.configList != null) {
      if (cidParameter != null) {
        if (!isNullOrEmpty(getConfigValue(sessionData?.configList, `PosLead.Landing.Faq.${cidParameter}`))) {
          setFaqText(JSON.parse(getConfigValue(sessionData?.configList, `PosLead.Landing.Faq.${cidParameter}`)))
        }
        else {
          if (!isNullOrEmpty(getConfigValue(sessionData?.configList, "PosLead.Landing.Faq"))) {
            setFaqText(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.Landing.Faq")))
          }
        }
      }
      else {
        setFaqText(JSON.parse(getConfigValue(sessionData?.configList, "PosLead.Landing.Faq")))
      }
    }
  }, [sessionData])

  return (
    <Page padding={false}>
      <Panel hasFooter={false} noHeader id={props.id} className="accordion-container">
        <Element type="h2">Bilmem gereken başka neler var?</Element>
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item: any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              ><Block dangerouslySetInnerHTML={{ __html: item?.data }} /></List.Item>
            )
          })}
        </List>
      </Panel>
    </Page>
  )
}

export default SssList
